import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=65075822&scoped=true&"
import script from "./VendorEdit.vue?vue&type=script&lang=js&"
export * from "./VendorEdit.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=65075822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65075822",
  null
  
)

export default component.exports